import './SearchButton.css';
import { Icon } from '../../components/Icon';
import { Kbd } from '../../components/Kbd';
import { t } from '../../copy/strings';
import { getOneKeyShortcuts, toggleSearch } from '../../state/actions';
import { useConfig, useTvOn, useUi } from '../../state/hooks';

/** Id do diálogo da busca (SearchPalette, Fase 11) e do campo dentro dele. */
export const SEARCH_DIALOG_ID = 'search-dialog';

/**
 * No celular a paleta fica montada e oculta (`hidden`); o toque remove `hidden` e foca o campo na MESMA tarefa, porque o
 * iOS só abre o teclado assim (§5.8 bloco 5). Sem a paleta no DOM (antes da Fase 11), não faz nada.
 */
function focusPaletteNow(): void {
  const dialog = document.getElementById(SEARCH_DIALOG_ID);
  if (!dialog) return;
  dialog.hidden = false;
  // o `hidden` da paleta fica no véu que envolve a caixa (SearchPalette)
  const veil = dialog.closest<HTMLElement>('[data-testid="search-palette"]');
  if (veil) veil.hidden = false;
  dialog.querySelector<HTMLInputElement>('input')?.focus();
}

/**
 * Botão Buscar (§5.8): lupa + "Buscar" + `Kbd` "Ctrl K"/"⌘K" no desktop; só a lupa num círculo de 44×44 no celular.
 * O clique chama `toggleSearch(true)`; a paleta é da Fase 11. Não existe na TV (AC-5.8-03). Com os atalhos de uma tecla
 * desligados (§15.2.7), o "/" sai de `aria-keyshortcuts` (Ctrl K e ⌘K continuam).
 */
export function SearchButton() {
  const tv = useTvOn();
  const ui = useUi();
  const zones = useConfig().features.zones;
  if (tv) return null;
  const label = t(zones ? 'search.button.ariaZones' : 'search.button.aria');
  return (
    <button
      type="button"
      class="search-button"
      data-testid="search-button"
      aria-label={label}
      aria-haspopup="dialog"
      aria-expanded={ui.searchOpen ? 'true' : 'false'}
      aria-controls={SEARCH_DIALOG_ID}
      aria-keyshortcuts={getOneKeyShortcuts() ? 'Control+K Meta+K /' : 'Control+K Meta+K'}
      onClick={() => {
        toggleSearch(true);
        focusPaletteNow();
      }}
    >
      <Icon name="search" size={16} />
      <span class="search-button__label">{t('search.button')}</span>
      <Kbd keys="search" ariaHidden />
    </button>
  );
}
